module.exports = __webpack_public_path__ + "assets/img/amazon-lex.3e66a7b6.png";